import React from 'react';
import styled from 'styled-components';

export default function InfoBox(props) {
  const {
    iconName,
    iconVariation="fas",
    label,
    value,
    details="",
  } = props;
  return (
    <Container>
    { iconName && (
      <Icon>
        <i className={`${iconVariation} fa-${iconName}`}></i>
      </Icon>
    )}
      <Label>{label}</Label>
      <Value>{value}</Value>
      <Details>{details}</Details>
    </Container>
  )
}

const Container = styled.div`
  display: grid;
  padding: 6px 0px;
  grid-template-columns: 38px 1fr;
  grid-template-rows: 14px 20px 12px;
  grid-template-areas:
    ". ."
    ". ."
    ". .";
`

const Icon = styled.span`
  grid-column: 1;
  grid-row: 1/4;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
`

const Label = styled.span`
  grid-column: 2;
  grid-row: 1;
  font-size: 12px;
`
const Value = styled.span`
  grid-column: 2;
  grid-row: 2;
  font-size: 18px;
`
const Details = styled.span`
  grid-column: 2;
  grid-row: 3;
  font-size: 10px;
`
